
import React from "react";
import { MapPin } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface RegionFilterProps {
  regionFilter: string | undefined;
  setRegionFilter: (region: string | undefined) => void;
  availableRegions: string[];
}

const RegionFilter: React.FC<RegionFilterProps> = ({
  regionFilter,
  setRegionFilter,
  availableRegions,
}) => {
  return (
    <div>
      <h4 className="text-sm font-medium mb-3 flex items-center">
        <MapPin className="h-4 w-4 mr-2" />
        Region
      </h4>
      <Select
        value={regionFilter}
        onValueChange={(value) => setRegionFilter(value === "all" ? undefined : value)}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder="All Regions" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Regions</SelectItem>
          {availableRegions.map((region) => (
            <SelectItem key={region} value={region}>
              {region}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default RegionFilter;
